import { defineMessages } from 'react-intl';

export default defineMessages({
  searchPlaceholder: {
    id: 'searchPlaceholder',
    description: 'search placeholder',
    defaultMessage: 'Search by name or design code',
  },
});
